import { Box } from "@mui/material";
import { SpecTable } from "./SpecTable";

export function SpecTab() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 2, gap: 2, bgcolor: "background.default" }}>
      <SpecTable />
    </Box>
  );
}
